import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/question-circle.svg")